import { template as template_edee16b81eb24a1b98222bc94681045c } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/html';
export default RouteTemplate(template_edee16b81eb24a1b98222bc94681045c(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
